import React from 'react';

export const Sewing = () => (
	<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M8.25 6L28.5 10.8144L28.5 29.25L8.25002 29.25L8.25001 17.625L8.25 6Z"
			fill="#FDC300"
		/>
		<path
			d="M25.4308 16.9659L28.8273 13.5694C29.6079 12.708 30.0272 11.5793 29.9986 10.4172C29.97 9.25505 29.4956 8.14842 28.6736 7.32641C27.8516 6.50441 26.745 6.02999 25.5828 6.00137C24.4207 5.97276 23.292 6.39215 22.4306 7.1727L19.0341 10.5692C17.7038 18.2962 5.25 30.75 5.25 30.75C5.25 30.75 17.7038 18.2962 25.4308 16.9659Z"
			fill="white"
		/>
		<path
			d="M25.6289 10.3711L23.3646 12.6354M25.4308 16.9659L28.8273 13.5694C29.6079 12.708 30.0272 11.5793 29.9986 10.4172C29.97 9.25505 29.4956 8.14842 28.6736 7.32641C27.8516 6.50441 26.745 6.02999 25.5828 6.00137C24.4207 5.97276 23.292 6.39215 22.4306 7.1727L19.0341 10.5692C17.7038 18.2962 5.25 30.75 5.25 30.75C5.25 30.75 17.7038 18.2962 25.4308 16.9659Z"
			stroke="#21282B"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
